module.exports = {
    props: ['user'],
    /**
     * The component's data.
     */
    data() {
        return {
            form: $.extend(true, new SparkForm({
                lkq_filter: '',
                auto_next: '',
                assignment_notification: '',
            }), Spark.forms.lkqPreferences)
        };
    },
    /**
     * Bootstrap the component.
     */
    mounted() {
        this.form.lkq_filter = this.user.lkq_filter;
        this.form.auto_next = this.user.auto_next;
        this.form.assignment_notification = this.user.assignment_notification;
    },
    methods: {
        /**
         * Update the user's contact information.
         */
        update() {
            console.log(this.form);
            Spark.put(`settings/preferences/lkq`, this.form)
                .then(() => {
                    Bus.$emit('updateUserData');
                });
        }
    }
};
